import React from "react";
import styled from "styled-components";
import { brand_orange_deep } from "../../constants/styles";
import { unmodule } from "../../util";
import { ModalContext } from "../../providers/ProvideModal";
import { apiGet } from "../../api";

const UnnamedComponent = (props) => {
  const [rules, setRules] = React.useState();
  const { openModal } = React.use(ModalContext);

  const openRules = React.useCallback((data) => {
    openModal({
      title: (
        <React.Fragment>
          Pengaturan Komisi Afiliator
          <PublishedAt>Per {data.comission_rule_last_updated_at}</PublishedAt>
        </React.Fragment>
      ),
      body: (
        <table>
          <thead>
            <tr>
              <th>Tipe</th>
              <th>Nama</th>
              <th>Komisi</th>
            </tr>
          </thead>
          <tbody>
            {data.comission_rules?.map((x) => (
              <tr key={`${x.type}-${x.name}`}>
                <td>{x.type}</td>
                <td>{x.name}</td>
                <td>{x.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ),
    });
  }, []);

  const handleClick = React.useCallback(async () => {
    if (rules) {
      openRules(rules);
    } else {
      const { parsedResponse, statusCode } = await apiGet(
        "/api/v1/users/affiliators/comission_rules",
      );
      if (statusCode === 200) {
        openRules(parsedResponse);
        setRules(parsedResponse);
      }
    }
  }, [rules]);

  return (
    <ComissionRuleDiv onClick={handleClick}>
      <img src={unmodule(require("../../images/icons/setting.svg"))} />
      <span>Comission Rules</span>
    </ComissionRuleDiv>
  );
};

export default UnnamedComponent;

const ComissionRuleDiv = styled.div`
  align-items: center;
  border-radius: 999px;
  border: 1px solid ${brand_orange_deep};
  color: ${brand_orange_deep};
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  font-weight: 700;
  gap: 6px;
  padding: 6px 14px;
  transition: background-color 150ms ease;

  &:hover {
    background-color: #fff7ed;
  }

  & > img {
    width: 16px;
    height: 16px;
  }
`;

const PublishedAt = styled.span`
  color: #9ca3af;
  font-size: 12px;
  margin: 0 5px;
  text-wrap: nowrap;
`;
